function decodeJwtPayload(token) {
  const jwt = token.startsWith("Bearer ") ? token.slice(7) : token;
  const parts = jwt.split(".");
  if (parts.length !== 3) {
    return null;
  }

  try {
    const base64 = parts[1].replace(/-/g, "+").replace(/_/g, "/");
    const padded = base64 + "=".repeat((4 - (base64.length % 4)) % 4);
    return JSON.parse(atob(padded));
  } catch {
    return null;
  }
}

export function parseStoredUser() {
  try {
    const raw = localStorage.getItem("user");
    if (!raw) {
      return null;
    }
    return JSON.parse(raw);
  } catch {
    return null;
  }
}

export function isValidAuthToken(token) {
  if (!token || typeof token !== "string" || !token.startsWith("Bearer ")) {
    return false;
  }

  const payload = decodeJwtPayload(token);
  if (!payload) {
    return false;
  }

  if (payload.exp && payload.exp * 1000 <= Date.now()) {
    return false;
  }

  return true;
}

export function isValidLoginResponse(data) {
  if (!data || data.success !== true) {
    return false;
  }

  if (!isValidAuthToken(data.token)) {
    return false;
  }

  if (data.role === undefined || data.role === null) {
    return false;
  }

  return true;
}

export function getStoredSessionToken() {
  const ssid = sessionStorage.getItem("ssid");
  if (!ssid) {
    return null;
  }

  try {
    return JSON.parse(ssid);
  } catch {
    return ssid;
  }
}

export function isAuthenticated() {
  const user = parseStoredUser();
  const sessionToken = getStoredSessionToken();

  if (!user || !sessionToken) {
    return false;
  }

  if (!isValidLoginResponse(user)) {
    return false;
  }

  return sessionToken === user.token;
}

export function clearSession() {
  localStorage.removeItem("user");
  sessionStorage.removeItem("ssid");
  localStorage.removeItem("cityId");
}

export function getLoginErrorMessage(data) {
  if (!data) {
    return "Login failed";
  }

  return (
    data.message ||
    data.userid ||
    data.password ||
    data.token ||
    "Invalid credentials"
  );
}
